import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { apiService } from './services/api';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { feLogger } from './utils/logger';

function RouteLogger() {
  const location = useLocation();
  useEffect(() => {
    feLogger.info('route_change', { pathname: location.pathname, search: location.search });
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    const handler = (event: ErrorEvent) => {
      feLogger.error('unhandled_error', event.error || event.message);
    };
    const rejHandler = (event: PromiseRejectionEvent) => {
      feLogger.error('unhandled_promise_rejection', event.reason);
    };
    window.addEventListener('error', handler);
    window.addEventListener('unhandledrejection', rejHandler);
    return () => {
      window.removeEventListener('error', handler);
      window.removeEventListener('unhandledrejection', rejHandler);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <RouteLogger />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}

// Защищенный роут
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = apiService.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

export default App; 